import { render, staticRenderFns } from "./CaseBlock.vue?vue&type=template&id=cf3439c2&scoped=true&"
import script from "./CaseBlock.vue?vue&type=script&lang=js&"
export * from "./CaseBlock.vue?vue&type=script&lang=js&"
import style0 from "./CaseBlock.vue?vue&type=style&index=0&id=cf3439c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3439c2",
  null
  
)

export default component.exports